// src/firebase.js
import {initializeApp} from 'firebase/app';
import {getAuth, GoogleAuthProvider, FacebookAuthProvider, OAuthProvider} from 'firebase/auth';

// Domaine de base : 'gapp-mobile-76928.firebaseapp.com'
const defaultAuthDomain = 'auth.guest-adom.com';

// Configuration de ton projet Firebase (trouvée dans la console)
const firebaseConfig = {
  // your application settings
  apiKey: 'AIzaSyA9IlUMZWeX6DYw07h157JjA4Qr3yUQApY',
  authDomain: defaultAuthDomain,
  projectId: 'gapp-mobile-76928',
  storageBucket: 'gapp-mobile-76928.firebasestorage.app',
  messagingSenderId: '146226904566',
  appId: '1:146226904566:web:669f924f28c52fa5631bd7',
  measurementId: 'G-VXT95R3M44', // Auth with popup/redirect
};

// Initialise Firebase
export const firebaseApp = initializeApp(firebaseConfig);

// Initialise le module d’authentification
export const auth = getAuth(firebaseApp);
auth.useDeviceLanguage();

// Google
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  redirect_uri: process.env.VUE_APP_AUTH_REDIRECT,
});

// Facebook
export const facebookAuthProvider = new FacebookAuthProvider();
facebookAuthProvider.addScope('email');
facebookAuthProvider.setCustomParameters({
  display: 'popup',
});

// Microsoft (OAuth)
export const microsoftAuthProvider = new OAuthProvider('microsoft.com');
microsoftAuthProvider.addScope('email');
microsoftAuthProvider.addScope('profile');
microsoftAuthProvider.setCustomParameters({
  // The default value is "common" (tenant-independent tokens).
  // Guestadom : 208fb997-b34d-4659-ba65-e805ded77cf1 // guestadomapp.onmicrosoft.com
  // tenant: 'guestadomapp.onmicrosoft.com',
  prompt: 'select_account',
});

// Apple (OAuth)
export const appleAuthProvider = new OAuthProvider('apple.com');
appleAuthProvider.addScope('email');
appleAuthProvider.addScope('name');
appleAuthProvider.setCustomParameters({
  // Localize the Apple authentication screen in French.
  locale: 'fr',
});

// Correspond aux constantes USER_MODE côté Back
export const userModeEnum = {
  NORMAL: 'NORMAL',
  GOOGLE: 'GOOGLE',
  FACEBOOK: 'FACEBOOK',
  MICROSOFT: 'MICROSOFT',
  APPLE: 'APPLE',
};

// HACK FIREBASE POUR NE PAS ATTENDRE 8 SECONDES APRES FERMETURE DE LA POP-UP
// Issue Github : https://github.com/firebase/firebase-js-sdk/issues/8061#issuecomment-2047370693
(function () {
  const originalSetTimeout = window.setTimeout;
  window.setTimeout = function (fn, delay, ...args) {
    // Check if the delay matches Firebase's _Timeout.AUTH_EVENT
    if (delay === 8000) {
      delay = 2000;
    }
    return originalSetTimeout(fn, delay, ...args);
  };
})();
